import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-header py-3" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "d-flex align-items-center gap-3" }
const _hoisted_5 = { class: "form-check form-switch mb-0 d-flex align-items-center" }
const _hoisted_6 = ["checked", "id"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_13 = {
  key: 1,
  class: "fas fa-save me-1"
}
const _hoisted_14 = { class: "card-body p-0" }
const _hoisted_15 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_16 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_17 = { class: "table table-hover align-middle mb-0" }
const _hoisted_18 = {
  key: 0,
  style: {"width":"40px"}
}
const _hoisted_19 = {
  key: 0,
  class: "text-center px-2"
}
const _hoisted_20 = { class: "text-center px-0" }
const _hoisted_21 = { class: "d-flex flex-column" }
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = {
  key: 0,
  class: "text-warning",
  title: "Se muestra como bloqueado si no tiene acceso"
}
const _hoisted_26 = {
  key: 1,
  class: "text-muted opacity-25",
  title: "Se oculta completamente si no tiene acceso"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "badge bg-info-subtle text-info border border-info-subtle rounded-pill px-2 d-inline-flex align-items-center gap-1 rank-badge" }
const _hoisted_30 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_33 = {
  key: 0,
  class: "small text-muted fw-medium"
}
const _hoisted_34 = {
  key: 1,
  class: "small text-muted"
}
const _hoisted_35 = { class: "text-end pe-4" }
const _hoisted_36 = { class: "d-inline-flex align-items-center gap-2 flex-nowrap actions-cell" }
const _hoisted_37 = ["onClick", "disabled"]
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = ["onClick", "disabled"]

import { ref, watch } from "vue";
import { useStore } from "vuex";
import type { PropType } from "vue";
import type { TelegramChannel } from "@/stores/telegramChannels";
import draggable from "vuedraggable";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseChannelsTable',
  props: {
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: "fa-list",
  },
  iconClass: {
    type: String,
    default: "text-primary",
  },
  channels: {
    type: Array as PropType<TelegramChannel[]>,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  mbClass: {
    type: String,
    default: "mb-4",
  },
  showInactive: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "edit",
  "delete",
  "create",
  "update:showInactive",
  "refresh",
  "update-order",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const isReordering = ref(false);
const savingOrder = ref(false);
const localChannels = ref<TelegramChannel[]>([]);

watch(
  () => props.channels,
  (newChannels) => {
    if (!isReordering.value) {
      localChannels.value = [...newChannels];
    }
  },
  { immediate: true }
);

const toggleReorder = () => {
  if (isReordering.value) {
    // Cancel: restore from props
    localChannels.value = [...props.channels];
    isReordering.value = false;
  } else {
    isReordering.value = true;
  }
};

const saveOrder = async () => {
  savingOrder.value = true;
  try {
    // Assign priorities based on index (higher index = lower priority)
    // We want the first item to have the highest priority.
    // Let's use 1000, 990, 980... or just length down to 1.
    const updates = localChannels.value.map((channel, index) => ({
      channelId: channel.id,
      priority: (localChannels.value.length - index) * 10,
    }));

    emit("update-order", updates);
    isReordering.value = false;
  } catch (error) {
    console.error("Error calculating order:", error);
  } finally {
    savingOrder.value = false;
  }
};

const getRankName = (rankId: string) => {
  const getter = store.getters["ranks/rankName"];
  if (typeof getter === "function") {
    const name = getter(rankId);
    return name || rankId;
  }
  return rankId;
};

const rankIconClass = (rankId: string) => {
  const getter = store.getters["ranks/rankIconClass"];
  if (typeof getter === "function") {
    const icon = getter(rankId);
    return icon || "fas fa-trophy";
  }
  return "fas fa-trophy";
};

const formatKickTime = (amount?: number, unit?: string) => {
  if (amount === 0) return "Inmediato";
  if (!amount) return "";
  const normalizedUnit = unit?.toLowerCase().replace(/s$/, "") || "day";
  const unitsMap: Record<string, string> = {
    day: "Días",
    week: "Semanas",
    month: "Meses",
    year: "Años",
  };
  return `${amount} ${unitsMap[normalizedUnit] || normalizedUnit}`;
};

return (_ctx: any,_cache: any) => {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card shadow-sm", __props.mbClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(["fas me-2", [__props.icon, __props.iconClass]])
          }, null, 2),
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              checked: __props.showInactive,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (
                _ctx.$emit(
                  'update:showInactive',
                  ($event.target as HTMLInputElement).checked
                )
              )),
              class: "form-check-input ms-0 me-2 cursor-pointer secondary",
              type: "checkbox",
              id: `showInactive-${__props.title.replace(/\s+/g, '-')}`
            }, null, 40, _hoisted_6),
            _createElementVNode("label", {
              class: "form-check-label cursor-pointer small fw-medium mb-0",
              for: `showInactive-${__props.title.replace(/\s+/g, '-')}`,
              style: {"white-space":"nowrap"}
            }, " Ver inactivos ", 8, _hoisted_7)
          ]),
          _createElementVNode("button", {
            class: "btn btn-light btn-sm me-2 text-muted",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh'))),
            disabled: __props.loading,
            title: "Actualizar Información"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-sync-alt", { 'fa-spin': __props.loading }])
            }, null, 2)
          ], 8, _hoisted_8),
          _createElementVNode("button", {
            class: "btn btn-add",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('create'))),
            disabled: __props.loading
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
            _createTextVNode("Nuevo ", -1)
          ]))], 8, _hoisted_9),
          (__props.channels.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn btn-sm", 
              isReordering.value ? 'btn-outline-warning' : 'btn-outline-secondary'
            ]),
                onClick: toggleReorder,
                disabled: __props.loading || savingOrder.value
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-sort me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(isReordering.value ? "Cancelar" : "Reordenar"), 1)
              ], 10, _hoisted_10))
            : _createCommentVNode("", true),
          (isReordering.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-success text-white btn-sm",
                onClick: saveOrder,
                disabled: savingOrder.value
              }, [
                (savingOrder.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                  : (_openBlock(), _createElementBlock("i", _hoisted_13)),
                _cache[6] || (_cache[6] = _createTextVNode(" Guardar Orden ", -1))
              ], 8, _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (__props.channels.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fas fa-inbox fa-2x text-muted mb-3" }, null, -1),
            _createElementVNode("p", { class: "text-muted mb-0" }, "No hay canales configurados en esta sección", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (isReordering.value)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_18))
                    : _createCommentVNode("", true),
                  _cache[8] || (_cache[8] = _createElementVNode("th", {
                    style: {"width":"120px"},
                    class: "py-3 text-center"
                  }, "Estado", -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("th", { class: "py-3" }, "Canal", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("th", {
                    class: "py-3 text-center",
                    style: {"width":"50px"},
                    title: "Visible cuando Bloqueado"
                  }, [
                    _createElementVNode("i", { class: "fas fa-eye" })
                  ], -1)),
                  _renderSlot(_ctx.$slots, "headers"),
                  _cache[11] || (_cache[11] = _createElementVNode("th", {
                    class: "py-3 text-center",
                    style: {"white-space":"nowrap"}
                  }, " Auto Admin ", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("th", {
                    class: "py-3 text-center",
                    style: {"white-space":"nowrap"}
                  }, " Auto Expulsar ", -1)),
                  _cache[13] || (_cache[13] = _createElementVNode("th", {
                    class: "py-3 text-end pe-4",
                    style: {"width":"116px","white-space":"nowrap"}
                  }, " Acciones ", -1))
                ])
              ]),
              _createVNode(_unref(draggable), {
                modelValue: localChannels.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localChannels).value = $event)),
                tag: "tbody",
                "item-key": "id",
                handle: ".drag-handle",
                disabled: !isReordering.value
              }, {
                item: _withCtx(({ element: channel }) => [
                  _createElementVNode("tr", {
                    class: _normalizeClass({ 'reordering-row': isReordering.value })
                  }, [
                    (isReordering.value)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "fas fa-grip-vertical drag-handle cursor-move text-muted" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", 
                      channel.active
                        ? 'bg-success-subtle text-success border border-success-subtle'
                        : 'bg-secondary-subtle text-secondary border border-secondary-subtle'
                    ])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-circle me-1 small", 
                        channel.active ? 'text-success' : 'text-secondary'
                      ])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(channel.active ? "Activo" : "Inactivo"), 1)
                      ], 2)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(channel.name), 1),
                        _createElementVNode("small", _hoisted_23, _toDisplayString(channel.id), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      (channel.visibleWhenRestricted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "fas fa-lock" }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("i", { class: "fas fa-eye-slash" }, null, -1)
                          ]))]))
                    ]),
                    _renderSlot(_ctx.$slots, "row", { channel: channel }),
                    _createElementVNode("td", _hoisted_27, [
                      (channel.minAdminRank)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, [
                              _createVNode(_component_rank_icon, {
                                "icon-class": rankIconClass(channel.minAdminRank),
                                "extra-class": "small"
                              }, null, 8, ["icon-class"]),
                              _createTextVNode(" " + _toDisplayString(getRankName(channel.minAdminRank)), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
                    ]),
                    _createElementVNode("td", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas me-2", 
                        channel.kickUsers
                          ? 'fa-check-circle text-success'
                          : 'fa-times-circle text-muted'
                      ])
                        }, null, 2),
                        (
                        channel.kickUsers &&
                        (channel.kickAfter || channel.kickAfter === 0)
                      )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(formatKickTime(channel.kickAfter, channel.kickAfterUnit)), 1))
                          : (!channel.kickUsers)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Desactivado"))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-action btn-users",
                          onClick: ($event: any) => (_ctx.$router.push(`/channels/${channel.id}/users`)),
                          disabled: __props.loading || isReordering.value,
                          title: "Gestionar Usuarios"
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("i", { class: "fas fa-users" }, null, -1)
                        ]))], 8, _hoisted_37),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-action btn-edit",
                          onClick: ($event: any) => (_ctx.$emit('edit', channel)),
                          disabled: __props.loading || isReordering.value,
                          title: "Editar"
                        }, [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                        ]))], 8, _hoisted_38),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-action btn-delete",
                          onClick: ($event: any) => (_ctx.$emit('delete', channel)),
                          disabled: __props.loading || isReordering.value,
                          title: "Eliminar"
                        }, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                        ]))], 8, _hoisted_39)
                      ])
                    ])
                  ], 2)
                ]),
                _: 3
              }, 8, ["modelValue", "disabled"])
            ])
          ]))
    ])
  ], 2))
}
}

})